import { defineStore } from 'pinia'


/**
 * @title 用于给组合选项卡状态存储
 */

export const useComponentTreeStore = defineStore('componentTree', {
    state: () => ({
        list: [],
        selected: {}
    }),
    actions: {
        setList(list) {
            this.list = list
        },
        setSelected(treeItem) {
            this.selected = treeItem
        }
    }
})